import { render, staticRenderFns } from "./FileLayout.vue?vue&type=template&id=5dd808a4&scoped=true"
import script from "./FileLayout.vue?vue&type=script&lang=js"
export * from "./FileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd808a4",
  null
  
)

export default component.exports